import React, { useState, useEffect } from 'react';

function DateLimitations({ closingDate, valueData, onChangeHandler, disabled, fieldName }) {
  const [maxDate, setMaxDate] = useState('');

  const [inputValue, setInputValue] = useState(valueData[fieldName]);


  useEffect(() => {
    if (closingDate) {
      const max = new Date(closingDate).toISOString().split("T")[0]; // One week in the future
      setMaxDate(max);
    }
  }, [closingDate]);

  useEffect(() => {
    if (fieldName === 'opinion_requested_by'
      || fieldName === 'opinion_due_date' ||
      fieldName === 'preliminary_letter_requested') {
      setInputValue(valueData[fieldName])
    }
  }, [valueData]);

  return (
    <div className="input-group">
      
      <input
        type='date'
        value={inputValue || ''}
        onChange={(e) => onChangeHandler(e)}
        className="form-control"
        disabled={disabled}
        placeholder="mm/dd/yyyy"
        min={new Date().toISOString().split("T")[0]}
        max={maxDate}
        onKeyDown={(e) => e.preventDefault()}
      />
    </div>
  );
}

export default DateLimitations;
